module.exports = __webpack_public_path__ + "img/library.fcaa86e5.jpeg";